import React from "react";
import PropTypes from "prop-types";
import PilaresDesktop from "./PilaresDesktop";

function Pilares({ app, config }) {

  return <PilaresDesktop app={app} config={config} />

}

Pilares.defaultProps = {
	app: null,
	config: {},
};

Pilares.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Pilares;
